<form [formGroup]="notificationPrefFormGroup">
    <h3 class="text-center">
        {{ "Notification" | translate }}
    </h3>

    <p class="text-muted text-center">
        {{ "Notification Description" | translate }}
        <br />

        {{ "Notification Preference Message" | translate }}
    </p>

    <div class="d-flex">
        <mat-radio-group
            class="m-auto"
            color="accent"
            aria-labelledby="notification-radio-group-label"
            formControlName="notificationPref">
            <table>
                <tr *ngFor="let type of notificationPreferences">
                    <td>
                        <mat-label>
                            {{ type }}
                        </mat-label>
                    </td>
                    <td>
                        <mat-radio-button [value]="type"></mat-radio-button>
                    </td>
                </tr>
            </table>
        </mat-radio-group>
    </div>
    <div class="d-flex">
        <mat-error *ngIf="!isFormValid" class="m-auto">
            Please select your notification preference.
        </mat-error>
    </div>
    <div class="d-flex my-3">
        <button
            type="button"
            class="btn btn-primary rounded-pill text-light m-auto"
            id="btn-continue"
            (click)="onSubmit()">
            {{ "Continue" | translate }}
        </button>
    </div>
    <p class="text-center">
        By saving you agree to our
        <a href="/terms-and-conditions"><u>Terms & Conditions</u></a>
        . Please refer to our
        <a href="/privacy-policy"><u>Privacy Statement</u></a>
        to learn about how we securely store and process your data.
    </p>
</form>
